import { createAction, props } from '@ngrx/store';
import { IBroadcast, ICreatePastor } from './dashboard.interface';

export const fetchPermissions = createAction(
	'[Dashboard Module] fetch all permissions'
);

export const fetchPermissionsSuccessful = createAction(
	'[Dashboard Module] STATUS: fetch all permissions successful',
	props<{ permissions: any }>()
);

export const fetchPermissionsFailed = createAction(
	'[Dashboard Module] STATUS: fetch all permissions failed'
);
export const fetchBroadcasts = createAction(
	'[Dashboard Module] fetch all broadcasts',props<{payload: any}>()
);

export const fetchBroadcastsSuccessful = createAction(
	'[Dashboard Module] STATUS: fetch all broadcasts successful',
	props<{ broadcasts: any }>()
);

export const fetchBroadcastsFailed = createAction(
	'[Dashboard Module] STATUS: fetch all broadcasts failed'
);

export const createBroadcast = createAction(
	'[Dashboard Module] create broadcast',
	props<{ payload: IBroadcast }>()
);

export const createBroadcastSuccessful = createAction(
	'[Dashboard Module] create broadcast successful'
);

export const createBroadcastFailed = createAction(
	'[Dashboard Module] create broadcast failed',
	props<{ message: string; code: number }>()
);
export const fetchPastors = createAction(
	'[Dashboard Module] fetch all pastors',props<{payload: any}>()
);

export const fetchPastorsSuccessful = createAction(
	'[Dashboard Module] STATUS: fetch all pastors successful',
	props<{ pastors: any }>()
);

export const fetchPastorsFailed = createAction(
	'[Dashboard Module] STATUS: fetch all pastors failed'
);

export const createPastor = createAction(
	'[Dashboard Module] create pastor',
	props<{ payload: ICreatePastor }>()
);

export const createPastorSuccessful = createAction(
	'[Dashboard Module] create pastor successful'
);

export const createPastorFailed = createAction(
	'[Dashboard Module] create pastor failed',
	props<{ message: string; code: number }>()
);

export const fetchJobs = createAction(
	'[Dashboard Module] fetch all jobs',props<{payload: any}>()
);

export const fetchJobsSuccessful = createAction(
	'[Dashboard Module] STATUS: fetch all jobs successful',
	props<{ jobs: any }>()
);

export const fetchJobsFailed = createAction(
	'[Dashboard Module] STATUS: fetch all jobs failed'
);